'use strict';

/**
 * See README.md for full description
 *
 * @module redux-middleware-adapter
 */

var _registeredMiddleware;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stage = {
    before: 'before',
    after: 'after'
};

var registeredMiddleware = (_registeredMiddleware = {}, _defineProperty(_registeredMiddleware, stage.before, {}), _defineProperty(_registeredMiddleware, stage.after, {}), _registeredMiddleware);

/**
 * middlewareAdapter is applied to the redux store. It is a standard redux middleware.
 * It is invoked after each dispatched action, prior to any reducer being called.
 * middlewareAdapter maintains a map of action types and callbacks. In response
 * to an action, it will invoke each of the callback functions that are
 * associated with that action's type.
 */
var middlewareAdapter = function middlewareAdapter(store) {
    return function (next) {
        return function (action) {
            if (registeredMiddleware[stage.before][action.type]) {
                registeredMiddleware[stage.before][action.type].forEach(function (middleware) {
                    return middleware(store, action);
                });
            }

            var result = next(action);

            if (registeredMiddleware[stage.after][action.type]) {
                registeredMiddleware[stage.after][action.type].reduce(function (_result, middleware) {
                    return middleware(store, action);
                }, result);
            }

            // return the state to follow Redux convention
            return result;
        };
    };
};

/**
 * registerMiddleware takes an actionType and a callback function.
 * When an action of the provided type is dispatched, the callback function will
 * be invoked by the middlewareAdapter.
 * The provided callback function takes 3 parameters, the store and the action.
 * These parameters may be omitted if they are not needed.
 * @param {String} actionType action type string of the action that is dispatched that the function is concerned with
 * @param {func} func middleware function that is listening to the action provided
 * @param {String} callTiming This can be either "before" or "after" and tells middleware adapter to call the middleware function
 * before or after the redux state is updated by the reducers handling the same action type. Default: "before"
 */
var registerMiddleware = function registerMiddleware(actionType, func) {
    var callTiming = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stage.before;

    /* istanbul ignore else */
    if (!registeredMiddleware[callTiming][actionType]) {
        registeredMiddleware[callTiming][actionType] = [];
    }

    // Only push the function on if it doesn't already exist. This protects against having multiple
    // copies of the same function which would happen during server-side initialization.
    if (registeredMiddleware[callTiming][actionType].indexOf(func) === -1) {
        registeredMiddleware[callTiming][actionType].push(func);
    }
};

module.exports = { registerMiddleware: registerMiddleware, middlewareAdapter: middlewareAdapter, registeredMiddleware: registeredMiddleware };
//# sourceMappingURL=index.js.map